import { http, HttpResponse } from 'msw'

import { api } from '@/utils/constants'

import { ParametersManagerRequest } from '@/types/shared/manager'

export const getTheme = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.settings.THEME}`,
    () => {
        return HttpResponse.json<ParametersManagerRequest>({
            results: [
                {
                    primary: '#F79728',
                    secondary: '#000000FF',
                    logo: 'logo/freego.png',
                    logo_konvive:
                        'https://api-dev.konvives.com/media/logo/freego_4lFyVUE.png',
                    has_order: true,
                    manager: {
                        id: 1,
                        name: 'FreeGo',
                    },
                },
            ],
        })
    },
)
